import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=5b3aa050&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=5b3aa050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3aa050",
  null
  
)

export default component.exports